import { reactive, Ref, toRef } from '@vue/composition-api';
import { Route } from 'vue-router';

export interface TrappRouteStore {
	route: Ref<string>;
	setFromRoute(s: Route): void;
}

export const getTrappRouteStore = (): TrappRouteStore => {
	const state = reactive({
		route: '',
	});
	const setFromRoute = (to: Route) => {
		state.route = '';
		const trappRouteGetter = to.meta.trappRoute;
		if (trappRouteGetter) {
			state.route = `/app${trappRouteGetter(to)}`;
		}
	};
	return {
		setFromRoute,
		route: toRef(state, 'route'),
	};
};
